// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dateOptionLabel_wrapper_zvJWKJj","divider":"dateOptionLabel_divider_31ltiGm"};